import { useCallback, useEffect } from 'react'
import { batch, useDispatch, useSelector } from 'react-redux'
import PageHeader from 'components/PageHeader'
import EditlogSearchForm from 'features/editlog/EditlogSearchForm'
import Table from 'components/table/Table'
import Pagination from 'components/pagination/Pagination'
import DetailLayer from 'features/editlog/layers/DetailLayer'
import {
  fetchEditlogs,
  hideEditlogDetail,
  reset,
  setPage,
} from 'features/editlog/editlogSlice'
import EditlogRow from './EditlogRow'

const Editlog = () => {
  const dispatch = useDispatch()
  const { isLoading, editlogs, detailVisible, page, total, size } = useSelector(
    state => state.editlog
  )
  const handlePageChange = useCallback(
    newPage => {
      batch(() => {
        dispatch(setPage(newPage))
        dispatch(fetchEditlogs())
      })
    },
    [dispatch]
  )

  const handleClose = () => {
    dispatch(hideEditlogDetail())
  }

  useEffect(() => {
    dispatch(fetchEditlogs())
    return () => dispatch(reset())
  }, [dispatch])

  return (
    <>
      <div className="settinghistory_wrap">
        <div className="dsp_tit">
          <PageHeader pageTitle="변경이력 관리" />
        </div>
        <div className="ad_managebox">
          <EditlogSearchForm />
          <div className="tblg2_wrap">
            <Table
              className="tbl_g2"
              caption="변경이력 표"
              emptyMessage={
                <>
                  등록된 내용이 없습니다.
                  <br />
                </>
              }
              loading={!!isLoading}>
              <Table.Head>
                <Table.Column title="변경일시" width="11.5%" />
                <Table.Column title="처리자" width="19.4%" />
                <Table.Column title="유형" width="8.9%" />
                <Table.Column title="이름" width="22.05%" />
                <Table.Column title="내용" />
                <Table.Column title="상세보기" width={110} />
              </Table.Head>
              <Table.Body>
                {editlogs.map(log => (
                  <EditlogRow key={log.id} {...log} />
                ))}
              </Table.Body>
            </Table>
          </div>
          {total > 0 && (
            <div className="paging_wrap">
              <div className="inner_paging">
                <Pagination
                  current={page}
                  total={total}
                  size={size}
                  onChange={handlePageChange}
                />
              </div>
            </div>
          )}
        </div>
      </div>
      <DetailLayer on={detailVisible} handleClose={handleClose} />
    </>
  )
}

export default Editlog
